<template>
  <q-dialog 
    :model-value="isModalOpen" 
    @update:model-value="$emit('closeAction')"
    persistent
  >
    <q-card class="dass-card-dialog full-width" style="max-height: 90vh; max-width: 75vw; min-width: 300px;">
      
      <q-card-section class="row  items-center q-pb-none q-gutter-xs">
        <div class="text-h6">{{ titleModal }}</div>
        <q-space />
        
        <q-btn 
          v-if="downloadAction"
          flat 
          round 
          dense 
          icon="download" 
          class="dass-btn-modal"
          @click="saveHtml"
        />
        
        <q-btn icon="close" class="dass-btn-modal" flat round dense v-close-popup @click="$emit('closeAction')" />
      </q-card-section>

      <q-separator />

      <q-card-section class="scroll" style="max-height: 70vh">
        <div class="column items-center q-gutter-md">
          <h3 class="q-ma-none text-center">{{ titleHtml }}</h3>
          
          <div class="full-width">
            <span v-html="emailHtml"></span>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import { printHtml } from '@/helpers/functions/printHtml'

export default {
  name: 'ModalPreviewEmail', 
  props: {
    isModalOpen: {
      type: Boolean,
      default: false
    },
    titleModal: {
      type: String,
      default: ''
    },
    titleHtml: {
      type: String,
      default: ''
    },
    emailHtml: {
      type: String,
      default: ''
    },
    downloadAction: {
      type: Boolean,
      default: false
    }
  },
  emits: ['closeAction'],
  methods: {
    saveHtml() {
      printHtml(this.emailHtml, this.titleHtml)      
    }
  }
}
</script>

<style lang="scss" scoped>
.dass-card-dialog {
    overflow: hidden;
}
.dass-btn-modal {
    color: var(--theme-color) !important;
}
@media (max-width: 700px) {
  .q-dialog__inner--minimized > div {
    max-width: 95vw !important;
  }
}
</style>